import React from 'react';
import Joyride from 'react-joyride';

import { STEP_FIELDS, MAX_ITEMS_TO_DISPLAY } from './constants';

export default class FeatureTour extends React.Component {
  constructor(props) {
    super(props);
  }

  deriveNewFeatureItemsToDisplay = (displayNewFeatureItems) => {
    return displayNewFeatureItems
      .sort((a, b) => {
        return a.rank - b.rank;
      })
      .slice(0, MAX_ITEMS_TO_DISPLAY);
  };

  deriveSteps = (itemsToDisplay) => {
    let steps = [];

    itemsToDisplay.forEach((element) => {
      const clean = element.steps.replace(/(?:\r\n|\r|\n)/g, '');
      const step = JSON.parse(clean);
      step.forEach((s) => {
        s[STEP_FIELDS.CONTENT] = <span dangerouslySetInnerHTML={{ __html: s[STEP_FIELDS.CONTENT] }} />;
        s[STEP_FIELDS.FEATURE_TOUR_ID] = element.id;
      });
      steps.push(...step);
    });

    return steps;
  };

  handleJoyrideCallback = (data) => {
    this.props.handleFeatureTourCallback(data);
  };

  handleError = (err) => {
    console.error(err);
    this.props.handleError(err);
  };

  deriveStepsWithErrorHandling = (displayNewFeatureItems) => {
    try {
      const itemsToDisplay = this.deriveNewFeatureItemsToDisplay(displayNewFeatureItems);
      return this.deriveSteps(itemsToDisplay);
    } catch (err) {
      this.handleError(err);
    }

    return [];
  };

  render() {
    const { runTour, displayNewFeatureItems } = this.props;
    const steps = this.deriveStepsWithErrorHandling(displayNewFeatureItems);

    return (
      <Joyride
        callback={this.handleJoyrideCallback}
        continuous={true}
        run={!!runTour}
        scrollToFirstStep={true}
        showProgress={true}
        showSkipButton={true}
        steps={steps}
        getHelpers={this.props.getHelpers}
        styles={{
          options: {
            primaryColor: '#000',
            textColor: '#000',
            zIndex: 1000,
          },
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/feature_tour/index.jsx